import { mapValues, omit } from 'lodash'
import { createCssCompNode } from '../cssCompNode'
import { LayoutRuntimeCSSPrefix } from './layoutRuntime.types'
import { CONTAINER_LAYOUTS_TYPES } from '../../utils/containerLayoutTypes'
import { LayoutDataItems } from '@wix/thunderbolt-becky-types'
import { ContainerLayouts, ItemLayouts } from '@wix/document-services-types'

type LayoutTypes = 'component' | 'container' | 'item'

type LayoutRuntimeObjectKeys = `--${typeof LayoutRuntimeCSSPrefix}-${LayoutTypes}`

type LayoutRuntimeCSSObject = Partial<Record<LayoutRuntimeObjectKeys, string>>

export const layoutRuntime = createCssCompNode('layoutRuntime', 'layoutRuntime', {
	getDependencies: (component, refs) => refs.compLayouts(component),
	toViewItem: (__, breakpointsToLayouts) => {
		if (!breakpointsToLayouts) {
			return null
		}

		const defaults: LayoutRuntimeCSSObject = {
			[`--${LayoutRuntimeCSSPrefix}-component`]: '',
			[`--${LayoutRuntimeCSSPrefix}-container`]: '',
			[`--${LayoutRuntimeCSSPrefix}-item`]: '',
		}

		const css = mapValues(breakpointsToLayouts, (variantsToLayouts) =>
			mapValues(variantsToLayouts, (layoutDataItems: Array<LayoutDataItems>) => {
				const layoutRuntimeCSSObject: LayoutRuntimeCSSObject = {}

				layoutDataItems.forEach((item) => {
					if (item.type === 'ComponentLayout') {
						layoutRuntimeCSSObject[`--${LayoutRuntimeCSSPrefix}-component`] = JSON.stringify(
							omit(item, 'id')
						)
						return
					}

					if (CONTAINER_LAYOUTS_TYPES.has(item.type)) {
						layoutRuntimeCSSObject[`--${LayoutRuntimeCSSPrefix}-container`] = JSON.stringify(
							omit(item as ContainerLayouts, 'id')
						)
						return
					}

					layoutRuntimeCSSObject[`--${LayoutRuntimeCSSPrefix}-item`] = JSON.stringify(
						omit(item as ItemLayouts, 'id')
					)
				})

				return layoutRuntimeCSSObject
			})
		)
		// to prevent CSS variables cascading from components higher in the hirarcy we force all properties on the default variant
		// @ts-ignore
		if (css.default) {
			// @ts-ignore
			css.default[''] = { ...defaults, ...css.default[''] }
		}

		return css
	},
})
